export const globalServicesManager = {
  header: {
    title: "Servizi ed esperienze",
    description: "Un solo elenco per tutto l'account. Scrivi ogni servizio una volta e scegli in quali annunci offrirlo.",
  },

  toolbar: {
    info: "Quello che crei qui compare nel tuo <strong>motore di prenotazione</strong> e nel tuo <strong>sito</strong>, negli annunci che selezioni.",
    newService: "Nuovo servizio",
  },

  loading: "Caricamento servizi…",

  empty: {
    title: "Non hai ancora servizi",
    description: "Un transfer, una visita guidata, un cesto di benvenuto… L'ospite li aggiunge prenotando.",
    create: "Crea il primo",
  },

  status: {
    active: "Attivo",
    paused: "In pausa",
  },

  price: {
    onRequest: "Su richiesta",
    free: "Gratis",
  },

  assign: {
    title: "In quali annunci si offre",
    listingsLabel: "I tuoi annunci",
    selectAll: "Seleziona tutti",
    clearAll: "Deseleziona tutti",
    inAll: "In tutti gli annunci",
    inSome: "In {n} su {total}",
    units: "{n} unità",
    pickRooms: "Scegli le camere",
    hideRooms: "Nascondi le camere",
    roomsHint: "Spunta solo le camere dove si offre. Senza spuntarne nessuna, si offre in tutte.",
    inRooms: "In 1 camera | In {count} camere",
    unassigned: "Non assegnato",
    helperNone: "Senza spuntare nulla, questo servizio NON si offre da nessuna parte.",
    roomsChecked: "1 spuntata · togliere | {count} spuntate · togliere",
    andMore: "+1 altra | +{count} altre",
    helper: "Senza selezionarne nessuno, il servizio si offre in tutti i tuoi annunci.",
  },

  actions: {
    edit: "Modifica",
    delete: "Elimina",
    cancel: "Annulla",
    save: "Salva",
  },

  delete: {
    title: "Elimina il servizio",
    text: "«{name}» non sarà più offerto in nessun annuncio. Non si può annullare.",
    accept: "Sì, elimina",
  },

  saved: {
    assign: "Annunci aggiornati",
    state: "Servizio aggiornato",
    deleted: "Servizio eliminato",
  },

  errors: {
    load: "Non siamo riusciti a caricare i tuoi servizi.",
    assign: "Non siamo riusciti a salvare gli annunci.",
    state: "Non siamo riusciti a modificare il servizio.",
    delete: "Non siamo riusciti a eliminare il servizio.",
  },
};
